export default {
  sections: {
    address: 'Adres',
    legal_address: 'Registratieadres',
    invoice_address: 'Factuuradres',
  },
  form: {
    display_name: {
      label: 'Vriendelijke naam',
      placeholder: 'Voer vriendelijke bedrijfsnaam in',
    },
    legal_name: {
      label: 'Juridische naam',
      placeholder: 'Voer juridische naam in',
      tooltip: 'Registratienaam. Weergegeven op uitbetalingsrapporten, contract, etc.',
    },
    timezone: {
      label: 'Tijdzone',
    },
    has_dedicated_invoice_address: {
      label: 'Andere factuurgegevens',
    },
  },
  buttons: {
    next: 'Volgende',
  },
};
